<template>
    <div class="dd-m-card dd-m-card--top-banner">
        <picture class="dd-m-card--top-banner__bg">
            <img :srcset="item.image.mobile" :alt="item.title">
        </picture>

        <div class="dd-m-card--top-banner__container">
            <div class="dd-m-card--top-banner__content">
                <h2 class="dd-m-card--top-banner__title">
                    {{item.title}}
                </h2>

                <a :title="item.title"
                   @click="checkIfQuizExists"
                   class="dd-m-button dd-m-button--assertive dd-m-button--sm">
                    {{item.textbutton}}
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'card-quiz-offline',
        props: ['item'],
        mounted() {
        },
        methods: {
            checkIfQuizExists() {
                if (localStorage[this.item.link]) {
                    const quiz = JSON.parse(localStorage[this.item.link]);
                    PubSub.publish('openOfflineQuizModal', quiz);
                } else {
                    PubSub.publish('openOfflineBannerMessageModal');
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/cards/card-quiz-offline.vue